<div class="dropdown" [ngClass]="{ home: isHome }">
  <button class="drop-button" data-testid="link-username">
    <span data-hook="users-name" class="name" data-hj-suppress>
      {{ (username$ | async)?.first_name }} {{ (username$ | async)?.last_name }}
    </span>
    <grid-ui-icon class="dropdown-caret" name="chevron-down" [useInlineSVG]="true"></grid-ui-icon>
  </button>
  <div class="dropdown-content">
    <ng-container *gridUiFeatureFlag="'subscriptions'">
      <p
        class="dropdown-item"
        data-hook="topUserMenuSubscriptions"
        (click)="clickSubscriptions()"
        *mcPermission="PermissionSelector.SUBSCRIPTIONS.MODULE"
        data-testid="option-my-subscription"
      >
        My Subscriptions
      </p>
    </ng-container>
    <p
      *mcPermission="PermissionSelector.GRID.ACCOUNT_SETTINGS"
      class="dropdown-item"
      data-hook="topUserMenuAccountSettings"
      (click)="clickAccountSettings()"
      data-testid="option-account-settings"
    >
      Account Settings
    </p>
    @if (showApiTokenMenuItem$ | async) {
      <ng-container *gridUiFeatureFlag="'release:api-token'">
        <p
          *mcPermission="PermissionSelector.API_TOKENS.MODULE"
          class="dropdown-item"
          data-hook="topUserMenuApiToken"
          (click)="clickApiToken()"
          data-testid="option-api-token"
        >
          {{ (isAccountAdmin$ | async) ? 'API Tokens' : 'My API Tokens' }}
        </p>
      </ng-container>
    }
    <p
      *mcPermission="PermissionSelector.GRID.ACCOUNT_SETTINGS"
      class="dropdown-item"
      data-hook="topUserMenuLogout"
      (click)="clickLogout()"
      data-testid="option-log-out"
    >
      Logout
    </p>
  </div>
</div>
